import { render, staticRenderFns } from "./PreExamsListQuestions.vue?vue&type=template&id=7f95fbff&scoped=true&"
import script from "./PreExamsListQuestions.vue?vue&type=script&lang=ts&"
export * from "./PreExamsListQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95fbff",
  null
  
)

export default component.exports